<template>
  <div class="shop-change-sync-status-dialog">
    <common-dialog
      :show.sync="innerVisible"
      title="申请人状态同步"
      class="staff-dialog"
    >
      <div class="shop-change-sync-status-body">
        <div class="title">请选择申请人状态同步的类型</div>
        <div class="option-list">
          <div class="option-item" v-for="item in syncStatusOptions" :key="item.value" @click="selectedValue = item.value">
            <div class="item-radio" :class="{active: item.value === selectedValue}"></div>
            <div class="option-content">
              <div class="option-name">{{item.label}}</div>
              <div class="option-desc">{{item.desc}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="staff-dialog-footer" slot="footer">
        <button @click="innerVisible = false" class="s-btn btn-info btn-lg">取消</button>
        <button @click="onSubmit" class="s-btn btn-blue btn-lg">确定</button>
      </div>
    </common-dialog>
  </div>
</template>

<script>
import CommonDialog from '../../../../components/common/modals/common-dialog/common-dialog.vue';
import { syncStatusOptions } from '@/maps/fliggy-maps';
import Http from '@/libs/http';

export default {
  components: {
    CommonDialog,
  },
  props: {
    visible: Boolean,
    shopInfo: Object,
  },
  data() {
    return {
      syncStatusOptions,
      selectedValue: 0,
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  watch: {
    innerVisible() {
      if (this.innerVisible) {
        this.init();
      }
    },
  },
  created() {},
  methods: {
    init() {
      this.selectedValue = this.shopInfo ? this.shopInfo.sync_type_id : 0;
    },
    async onSubmit() {
      if (!this.shopInfo) return;
      await Http.post('/peer_ota_sync_type_update', { sync_type_id: this.selectedValue, id: this.shopInfo.id });
      this.$message({
        message: '修改成功',
        type: 'success',
      });
      this.$emit('submit', this.selectedValue);
      this.innerVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.shop-change-sync-status-body{
  padding: 32px 24px;
  .title{
    color: #2F333D;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
  }
  .option-list{
    margin-top: 16px;
    .option-item{
      display: flex;
      align-items: flex-start;
      margin-bottom: 16px;
      cursor: pointer;
      &:last-child{
        margin-bottom: 0;
      }
      .item-radio{
        margin-top: 2px;
        flex-shrink: 0;
        margin-right: 4px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid #DEE2E6;
        &.active{
          border: 4px solid #599FFF;
        }
      }
      .option-content{
        color: #2F333D;
        font-size: 14px;
        line-height: 20px;
        .option-desc{
          color: #AAAAAA;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/user/user-children/components/shop-change-sync-status-dialog.vue